import { useState } from "react";
import {
  AddressBookIcon,
  PasteIcon,
  UserGroupIcon,
} from "../../../../assets/svgIcons";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdateSmsCampaigns } from "../../../../hooks/api/mutations/useMarketing";
import { pathConstants } from "../../../../routes/pathContants";
import { cleanObject } from "../../../../helpers";

export const useSmsCampaignAudienceForm = ({ smsCampaign = {} }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const audienceTypes = [
    {
      name: "Automated Segment",
      id: "automated",
      icon: <UserGroupIcon className="mr-1" style={{ fontSize: "20px" }} />,
    },
    {
      name: "Phone Book",
      id: "phone_book",
      icon: <AddressBookIcon className="mr-1" style={{ fontSize: "20px" }} />,
    },
    {
      name: "Copy & Paste",
      id: "manual",
      icon: <PasteIcon className="mr-1" style={{ fontSize: "20px" }} />,
    },
  ];
  const [currentAuidence, setCurrentAuidence] = useState("automated");
  const [formData, setFormData] = useState({
    title: smsCampaign?.title || "",
    audience_id: smsCampaign?.audience?.id || "",
    no_of_audience: smsCampaign?.audience?.customer_count || 0,
    customer_ids: smsCampaign?.customers?.map((customer) => customer.id) || [],
    exclude_customer_ids: [],
    recipient_phone_numbers: (smsCampaign?.recipient_phone_numbers || [])?.join(
      ", ",
    ),
    select_all_customers: false,
  });

  const { mutate: updateSmsCampaign, isLoading: isSubmiting } =
    useUpdateSmsCampaigns(id);
  const handleSubmitAudience = () => {
    updateSmsCampaign(
      {
        data: cleanObject(
          {
            ...formData,
            audience_id:
              formData?.audience_id === "" ? null : formData?.audience_id,
            recipient_phone_numbers: formData?.recipient_phone_numbers
              ?.split(",")
              ?.map((number) => number?.trim())
              ?.filter((number) => number && number !== ""),
          },
          [],
          ["audience_id"],
        ),
        id,
      },
      {
        onSuccess: () => {
          navigate(pathConstants.MARKETING_SMS_CAMPAIGNS_CONTENT({ id }));
        },
      },
    );
  };

  return {
    formData,
    audienceTypes,
    currentAuidence,
    isSubmiting,
    setFormData,
    setCurrentAuidence,
    handleSubmitAudience,
  };
};
